const ArrowTurnRight = (
    <g>
        <path d="m15 10.5h-10.25c-1.517 0-2.75-1.233-2.75-2.75v-4c0-.414.336-.75.75-.75s.75.336.75.75v4c0 .689.561 1.25 1.25 1.25h10.25c.414 0 .75.336.75.75s-.336.75-.75.75z" />
        <path d="m11 14.7498c-.192 0-.384-.073-.53-.22-.293-.293-.293-.768 0-1.061l3.72-3.72-3.72-3.72c-.293-.293-.293-.768 0-1.061s.768-.293 1.061 0l4.25 4.25c.293.293.293.768 0 1.061l-4.25 4.25c-.146.146-.338.22-.53.22z" />
    </g>
);

export { ArrowTurnRight };
